/**
 * @generated SignedSource<<a875d7175131d081dd993227c298d276>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type timelinesInSuperSplashHomeV2LiveQuery$variables = {
  entityUuid: string;
};
export type timelinesInSuperSplashHomeV2LiveQuery$data = {
  readonly liveArticle: {
    readonly liveContents: ReadonlyArray<{
      readonly entityId: string;
      readonly publishedDate: number | null | undefined;
      readonly title: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type timelinesInSuperSplashHomeV2LiveQuery = {
  response: timelinesInSuperSplashHomeV2LiveQuery$data;
  variables: timelinesInSuperSplashHomeV2LiveQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityUuid"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityUuid",
        "variableName": "entityUuid"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveContent",
  "kind": "LinkedField",
  "name": "liveContents",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedDate",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "timelinesInSuperSplashHomeV2LiveQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LiveArticle",
        "kind": "LinkedField",
        "name": "liveArticle",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "timelinesInSuperSplashHomeV2LiveQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LiveArticle",
        "kind": "LinkedField",
        "name": "liveArticle",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c6f8c180161741915c3a505479258a66",
    "id": null,
    "metadata": {},
    "name": "timelinesInSuperSplashHomeV2LiveQuery",
    "operationKind": "query",
    "text": "query timelinesInSuperSplashHomeV2LiveQuery(\n  $entityUuid: String!\n) {\n  liveArticle(filter: {entityUuid: $entityUuid}) {\n    liveContents {\n      entityId\n      title\n      publishedDate\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "17e841354328c71b0b2b59a2b70e5609";

export default node;
